var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyS3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.4 198.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M78.1 52.5h102.4v85.9H47.1v-22.6M78.1 70.1h6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    strokeDasharray: "11.5,11.5",
    d: "M95.8 70.1H160"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M165.8 70.1h6v6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    strokeDasharray: "14.25,14.25",
    d: "M171.8 90.3v21.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M171.8 118.9v6h-6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    strokeDasharray: "11.5,11.5",
    d: "M154.3 124.9H68"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M62.3 124.9h-6v-5.3M105.8 139.8v8.5c-.1 9.9-10.5 9.6-10.5 9.6H71v6.4h85.9l-.1-6.4h-24.3s-10.5.4-10.5-9.6v-8.5M78.1 108.7v4.1c0 1.7-1.4 3-3 3h-60c-1.7 0-3-1.4-3-3V34.7c0-1.7 1.4-3 3-3h47.3L78.1 46v41M78.1 46H62.5M62.5 46V31.6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M65.3 93.9v7.9h20.2v9.5l13.4-14.1-13.7-12.9v9.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "B_4L_main",
    d: "M72.5 74c-.2.7-.5 1.3-.7 1.9-.8 2.2-1.6 4.5-2.4 6.7-.1.2-.2.4-.2.6-.3.8-.8 1.3-1.6 1.5H66v-1.6h.7c.8-.1 1.2-.7.9-1.5-.8-2.4-1.7-4.7-2.5-7.1-.1-.1-.1-.3-.2-.5h2c.1 0 .3.2.3.4.5 1.5.9 3.1 1.4 4.6 0 .2.1.3.2.6.5-1.9 1.1-3.8 1.6-5.6h2.1zM41.9 81.6h-2V81v-4.3c0-.8-.4-1.2-1-1.3-.7 0-1.2.4-1.4 1.1v5h-2V81v-4.3c0-.9-.4-1.3-1.2-1.3-.8 0-1.2.5-1.2 1.4V81.5h-2V74H33v1.1c.6-.9 1.3-1.3 2.2-1.3.9 0 1.7.3 2.2 1.3.1-.1.1-.2.1-.3.8-1 1.8-1.2 3-.8 1 .4 1.5 1.2 1.5 2.4-.1 1.7-.1 3.4-.1 5.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "B_4L_main",
    d: "M63.5 79.4c-.1 0-.3.1-.4.2-.5.6-1.2.8-2 .5-.6-.3-1-.9-.9-1.7h5.2c-.1-.6-.1-1.2-.2-1.7-.3-1.7-1.5-2.8-3.2-2.9-2.1-.1-3.4.8-3.8 2.7-.2 1-.2 2 .1 3 .3 1.2 1.1 2 2.3 2.2.7.1 1.5.2 2.3 0 1.2-.2 2.2-1.3 2.3-2.3-.5 0-1.1-.1-1.7 0zm-1.6-4c.8 0 1.4.7 1.4 1.5h-3c.1-1 .6-1.5 1.6-1.5zM48.3 74.2c-2.2-1.1-5.9-.3-5.9 3.9 0 1.2.5 2.5 1.9 3.3 2.8 1.5 6-.3 6-3.5 0-1.6-.5-3-2-3.7zm-.3 4.6c-.2.8-.9 1.3-1.7 1.3-.8 0-1.4-.5-1.7-1.3-.2-.7-.2-1.5 0-2.2.2-.8.8-1.2 1.6-1.2s1.4.4 1.7 1.2c.3.5.2 1.9.1 2.2zM57.8 81.6h-2v-2.4V77c0-1-.4-1.5-1.2-1.5-.9 0-1.6.6-1.6 1.5v4.7h-2V74h1.9v.9c.1 0 .2-.1.2-.1.8-1 1.9-1.3 3.2-.8 1 .4 1.6 1.2 1.6 2.4-.1 1.7-.1 3.4-.1 5.2zM32 61.5v6.4h-3v-3.4h-3.4v-3zM25.6 68.6H32v3h-3.4V75h-3zM18.7 75v-6.4h3V72h3.4v3zM25.1 67.9h-6.4v-3h3.4v-3.4h3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyS3);
export default __webpack_public_path__ + "static/media/MoneyS3.7c97da40bc48c940bc10517a43115e24.svg";
export { ForwardRef as ReactComponent };